module.exports = __webpack_public_path__ + "img/angrycreative.ab19036e.svg";